// src/redux/actions/salesActions.js
import {
    UPDATE_SALES_WALKTHROUGH_REQUEST,
    UPDATE_SALES_WALKTHROUGH_SUCCESS,
    UPDATE_SALES_WALKTHROUGH_FAILURE,

} from '../../../../Constants/actionTypes';

import { updateSalesWalkthorugh } from '../../../../Constants/apiService'



// Fetch Sales Request Action
export const updateSalesWalkthorughStatusRequest = () => ({
    type: UPDATE_SALES_WALKTHROUGH_REQUEST,
});

// Fetch Sales Success Action
export const updateSalesWalkthorughStatusSuccess = (salesData) => ({
    type: UPDATE_SALES_WALKTHROUGH_SUCCESS,
    payload: salesData,

});

// Fetch Sales Failure Action
export const updateSalesWalkthorughStatusFailure = (error) => ({
    type: UPDATE_SALES_WALKTHROUGH_FAILURE,
    payload: error,
});




// Thunk Action Creator for Fetching Sales
export const updateSalesWalkthorughStatusAct = (navigate) => {
  
    return async (dispatch, getState) => {
        dispatch(updateSalesWalkthorughStatusRequest());

        const state = getState();
        const accessToken = state.auth.accessToken;


        try {
            const data = await updateSalesWalkthorugh(accessToken);


            if (data?.success) {
                dispatch(updateSalesWalkthorughStatusSuccess(data));
                navigate("/home");
            } else {
                throw new Error('Unexpected API response format');
            }
           
            // dispatch(updateDemoSessionSuccess(data));
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(updateSalesWalkthorughStatusFailure(errorMessage));
        }
    };
};

